import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Smooth scroll (Lenis) synchronisé avec GSAP ScrollTrigger.
 * Lenis anime le scroll natif : les pins ScrollTrigger fonctionnent sans scroller proxy.
 */
export default class SmoothScroll {
	constructor({ onScroll } = {}) {
		this.scroll = new Lenis({
			lerp: 0.1,
			wheelMultiplier: 1,
			smoothWheel: true,
		});

		this.scroll.on("scroll", () => {
			ScrollTrigger.update();
			onScroll?.();
		});

		gsap.ticker.add((time) => {
			this.scroll.raf(time * 1000);
		});
		gsap.ticker.lagSmoothing(0);

		requestAnimationFrame(() => ScrollTrigger.refresh());
	}

	disable() {
		this.scroll.stop();
	}

	enable() {
		this.scroll.start();
	}

	scrollTo(elt, offset = 0) {
		this.scroll.scrollTo(elt, {
			offset,
			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		});
	}

	update() {
		this.scroll.resize();
	}

	destroy() {
		this.scroll.destroy();
	}
}
